import { useState, useMemo } from "react";
import { Datagrid } from "react-admin";
import { Box, TextField } from "@mui/material";

const LocalPagination = ({ page, perPage, total, setPage }) => {
  const totalPages = Math.ceil(total / perPage);
  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i}
          onClick={() => setPage(i + 1)}
          style={{
            margin: "0 4px",
            fontWeight: page === i + 1 ? "bold" : "normal",
          }}
        >
          {i + 1}
        </button>
      ))}
    </Box>
  );
};

function flattenValues(value) {
  if (value == null) return "";
  if (Array.isArray(value)) return value.map(flattenValues).join(" ");
  if (typeof value === "object")
    return Object.values(value).map(flattenValues).join(" ");
  return String(value);
}

export const LocalDataGrid = ({ data, perPage = 5, ...props }) => {
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    if (!filter) return data;
    return data.filter((record) => {
      const haystack = Object.values(record)
        .map(flattenValues)
        .join(" ")
        .toLowerCase();
      const terms = filter.toLowerCase().split(/\s+/).filter(Boolean);
      return terms.every((term) => haystack.includes(term));
    });
  }, [data, filter]);

  const paginated = useMemo(() => {
    const start = (page - 1) * perPage;
    return filtered.slice(start, start + perPage);
  }, [filtered, page, perPage]);

  return (
    <Box>
      <Box sx={{ padding: "8px 24px" }}>
        <TextField
          label="Search"
          value={filter}
          onChange={(e) => {
            setFilter(e.target.value);
            setPage(1);
          }}
        />
      </Box>

      <Datagrid data={paginated} {...props} />

      <LocalPagination
        page={page}
        perPage={perPage}
        total={filtered.length}
        setPage={setPage}
      />
    </Box>
  );
};
